import { Box, type SxProps, type Theme } from "@mui/material";

import FernieFace from "~/components/fernie/FernieFace";
import FernieName from "~/components/fernie/FernieName";
import { clampMarkSize, type FernieFaceState } from "~/components/fernie/fernieMarkRules";
import { fernieColors } from "~/themes/fernieBrand";

interface FernieInlineLockupProps {
	state?: FernieFaceState;
	size?: number;
	trademark?: boolean;
	nameColor?: string;
	sx?: SxProps<Theme>;
}

const FernieInlineLockup = ({
	state = "rest",
	size = 32,
	trademark = true,
	nameColor = fernieColors.tile,
	sx
}: FernieInlineLockupProps) => {
	const width = clampMarkSize("face", size);

	return (
		<Box sx={{ alignItems: "center", display: "inline-flex", flexDirection: "row", gap: `${width * 0.28}px`, ...sx }}>
			<FernieFace state={state} size={width} decorative />
			<FernieName trademark={trademark} color={nameColor} fontSize={width * 0.62} />
		</Box>
	);
};

export default FernieInlineLockup;
